package org.vreo.devicehub.features.userAuthentication.presentation.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredSize
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Visibility
import androidx.compose.material.icons.filled.VisibilityOff
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.material3.TextFieldColors
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp


/**
 * Password Outlined Text Field.
 *
 * @param value value
 * @param onValueChange value change handler
 * @param modifier modifier
 * @param isError is error, if true error outline will be shown
 * @param keyboardOptions keyboard options
 * @param keyboardActions keyboard actions
 * @param colors colors (using TextFieldColors for Material3 compatibility)
 * @param placeholder placeholder
 */
@Composable
fun PasswordOutlinedTextField(
    value: String,
    onValueChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    isError: Boolean = false,
    keyboardOptions: KeyboardOptions = KeyboardOptions.Default,
    keyboardActions: KeyboardActions = KeyboardActions.Default,
    colors: TextFieldColors = TextFieldDefaults.colors(),
    placeholder: @Composable (() -> Unit)? = {
        Text(text = "Enter Password")
    }
) {
    var showPassword by remember { mutableStateOf(false) }

    OutlinedTextField(
        value = value,
        visualTransformation = if (showPassword) {
            VisualTransformation.None
        } else {
            PasswordVisualTransformation()
        },
        onValueChange = onValueChange,
        modifier = modifier,
        placeholder = placeholder,
        colors = colors,
        singleLine = true,
        isError = isError,
        keyboardOptions = keyboardOptions,
        keyboardActions = keyboardActions,
        trailingIcon = {
            Icon(
                if (showPassword) {
                    Icons.Filled.Visibility
                } else {
                    Icons.Filled.VisibilityOff
                },
                contentDescription = if (showPassword) "Hide password" else "Show password",
                modifier = Modifier
                    .requiredSize(48.dp).padding(16.dp)
                    .clickable { showPassword = !showPassword }
            )
        }
    )
}

@Preview
@Composable
fun PasswordOutlinedTextFieldPreview() {
    MaterialTheme {
        PasswordOutlinedTextField(
            value = "12345",
            onValueChange = {},
            isError = false,
            modifier = Modifier.padding(16.dp)
        )
    }
}